import { render, staticRenderFns } from "./riskPhoneOnline.vue?vue&type=template&id=13daa17e&"
import script from "./riskPhoneOnline.vue?vue&type=script&lang=js&"
export * from "./riskPhoneOnline.vue?vue&type=script&lang=js&"
import style0 from "./riskPhoneOnline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports